import { usePaneContext } from "@/components/pane/paneContext";
import { EWidgetType } from "@/domain/enums/dashboard.enum";
import { useGrid } from "@/hooks/useGrid";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Accounts } from "./accounts/accounts";
import { RiskManager } from "./risk-manager/risk-manger";
import { Algos } from "./algos/algos";
import { Configs } from "./configs/configs";
import { hasAccessToWidget } from "@/domain/constants";
import { useUserStore } from "@/lib/stores/userStore";
import { useMarketplaceStore } from "@/lib/stores/useMarketplaceStore";

export default function TradingPaneBody() {
  const nodeId = usePaneContext();
  const { node, getNodeConfig } = useGrid(nodeId);
  const widgetType = node?.getComponent() as EWidgetType;
  const config = getNodeConfig();
  const { user } = useUserStore();
  const { purchasedProductIds } = useMarketplaceStore();

  if (
    !hasAccessToWidget(user?.role || "GUEST", widgetType, purchasedProductIds)
  ) {
    return (
      <div className="flex flex-col h-[calc(100%-48px)] items-center justify-center space-y-2">
        <p>No access</p>
        <div className="text-sm">You should login to use this widget</div>
      </div>
    );
  }
  return (
    <>
      <Tabs defaultValue="algos" className="p-1 h-[calc(100%-48px)]">
        <TabsList className="grid grid-cols-6 bg-neutral-950 gap-1">
          <TabsTrigger
            className="text-xs text-white border border-neutral-800 uppercase data-[state=active]:bg-white data-[state=active]:text-black"
            value="accounts"
          >
            Accounts
          </TabsTrigger>
          {/* <TabsTrigger
            className="text-xs text-white border border-neutral-800 uppercase data-[state=active]:bg-white data-[state=active]:text-black"
            value="riskManager"
          >
            Risk
          </TabsTrigger> */}
          <TabsTrigger
            className="text-xs text-white border border-neutral-800 uppercase data-[state=active]:bg-white data-[state=active]:text-black"
            value="algos"
          >
            Algos
          </TabsTrigger>
          <TabsTrigger
            className="text-xs text-white border border-neutral-800 uppercase data-[state=active]:bg-white data-[state=active]:text-black"
            value="configs"
          >
            Configs
          </TabsTrigger>
        </TabsList>

        <TabsContent value="accounts" className="h-full">
          <Accounts />
        </TabsContent>
        {/* <TabsContent value="riskManager" className="h-full">
          <RiskManager />
        </TabsContent> */}
        <TabsContent value="algos" className="h-full">
          <Algos />
        </TabsContent>
        <TabsContent value="configs" className="h-full">
          <Configs />
        </TabsContent>
      </Tabs>
    </>
  );
}
